module.exports = __webpack_public_path__ + "static/homepage1-a8ae4ccfb281901346cab549c30147e0.png";